// events.ts
import { graphql, useStaticQuery } from "gatsby";

export const eventsQuery= () =>{ 
    const data = useStaticQuery(graphql`
    query {
        allWpEvent(sort: {date: DESC}) {
          years: nodes {
            date(formatString: "DD MMMM, YYYY")
            title
            dateGmt
            startDate
            calendarEvents {
              watchEventButton
              viewEventFlyer {
                link
              }
              calendarRepeater {
                personImg {
                  sourceUrl
                }
                personName
                personDesc
              }
            }
          }
        }
      }
    `)

    return data.allWpEvent.years;
};

